module.exports = __webpack_public_path__ + "static/media/polygonal-mosaic-background.e2dfaea8.png";